// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"308":"aa3d301e","355":"62ae1c12","624":"62ae1c12","897":"5412ef63","959":"62ae1c12"}[chunkId] + ".chunk.css";
};